function setWidthContentHeaderPicture () {
  const windowWidth = window.innerWidth,
        pic = document.querySelector('#js-content-header');
  
  if (pic) {
    const rect = pic.getBoundingClientRect();
    pic.style.width = (windowWidth - rect.x) + 'px';
  }
}

export {
  setWidthContentHeaderPicture
}
